// removed by extract-text-webpack-plugin
module.exports = {"container":"_3sonpri","container__noBackground":"_2uQ-C2e"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/ListContainer/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/ListContainer/index.css
// module chunks = client.sitechrome